<template>
  <div class="person" v-loading="loading">
    <el-form ref="form" :model="form" label-width="150px">
      <el-card shadow="hover">
        <el-form-item
          :label="$t('homePage.filter')"
        >
          <el-checkbox
            v-model="searchConditions.productStatus"
            :label="$t('addConfigModule.hideDeliSting')"
          />
          <el-checkbox
            v-model="searchConditions.isSpecialControlled"
            :label="$t('addConfigModule.hiddenFor')"
          />
          <el-checkbox
            v-model="searchConditions.showOpticalModule"
            :label="$t('addConfigModule.hideLightModule')"
          />
          <el-checkbox
            v-model="searchConditions.showHost"
            :label="$t('addConfigModule.accordingHost')"
          />
          <el-checkbox
            v-model="searchConditions.showHostAndOpticalModule"
            :label="$t('addConfigModule.hostLightModule')"
          />
          <el-checkbox
            v-model="searchConditions.showService"
            :label="$t('homePage.accordingProvider')"
          />
        </el-form-item>
      </el-card>
      <el-card shadow="hover">
        <div slot="header" class="clearfix">
          <div class="title">{{ $t('homePage.exportDefault') }}</div>
          <el-form-item
            :label="$t('homePage.whetherOpen')"
            style="float: right;"
          >
            <el-switch v-model="form.exportSwitch" />
          </el-form-item>
        </div>
        <el-form-item
          :label="$t('exportExcelModule.exportField')"
        >
          <el-row :gutter="24">
            <el-col :span="22">
              <el-checkbox-group
                v-model="checkedExportFields"
              >
                <el-checkbox
                  v-for="item in form.exportFields"
                  :key="item.typeKey"
                  :label="item.typeValue"
                  :disabled="(mergeFlag === '2' && item.typeKey === 'showOrder')||(mergeFlag === '2' && item.typeKey === 'showProductNotes')||(mergeFlag !== '3' && item.typeKey ==='showProductSeries')||(mergeFlag !== '3' && item.typeKey ==='showSingleSetPrice')||(mergeFlag !== '3' && item.typeKey ==='showSingleSetPriceDiscount')"
                >
                  {{ item.typeValueEn }}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('exportExcelModule.exportFormat')">
          <el-row :gutter="24">
            <el-col :span="22">
              <el-checkbox-group
                v-model="checkedExportFormats"
              >
                <el-checkbox
                  @change="onchangeFormat(item.typeValue)"
                  v-for="item in form.exportFormats"
                  :key="item.typeKey"
                  :label="item.typeValue"
                >
                  {{ item.typeValueEn }}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </el-form-item>
      </el-card>

      <el-card shadow="hover">
        <div slot="header" class="clearfix">
          <div class="title">{{ $t('homePage.productAutomaticMemory') }}</div>
          <el-form-item :label="$t('homePage.whetherOpen')" style="float: right;">
            <el-switch v-model="form.defaultProductNameSwitch" />
          </el-form-item>
        </div>
      </el-card>

      <el-card shadow="hover">
        <div slot="header" class="clearfix">
          <div class="title">{{ this.$t('homePage.parameterAutomaticMemory') }}</div>
          <el-form-item :label="$t('homePage.whetherOpen')" style="float: right;">
            <el-switch v-model="form.defaultParamsSwitch" />
          </el-form-item>
        </div>
      </el-card>

      <el-form-item class="person-config-button">
        <el-button type="primary" @click="onSubmit" size="small">
          {{ $t('createQuotation.totalQuantity') }}
        </el-button>
        <el-button size="small" @click="cancel">
          {{ $t('addConfigModule.cancel') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="es6">
import api from '../../api';
export default {
  data () {
    return {
      mergeFlag: '3',
      loading: false,
      form: {
        exportFields: [],
        exportFormats: []
      },
      checkedExportFields: [],
      checkedExportFormats: [],
      searchConditions: {
        preproduction: false,
        stopProduction: false,
        productStatus: false,
        isSpecialControlled: false,
        showOpticalModule: false,
        showHost: false,
        showService: false,
        showHostAndOpticalModule: false
      }
    };
  },
  methods: {
    onchangeFormat (row) {
      if (row === '合并（不显示产品明细）') {
        if (this.checkedExportFormats.indexOf(row) > -1) {
          this.checkedExportFormats.forEach((item, i) => {
            if (item === '合并（显示产品明细）') {
              this.checkedExportFormats.splice(i, 1);
            }
          });
          this.checkedExportFields.forEach((item, i) => {
            if (item === '下单属性') {
              this.checkedExportFields.splice(i, 1);
            }
          });
          this.checkedExportFields.forEach((item, i) => {
            if (item === '特殊说明') {
              this.checkedExportFields.splice(i, 1);
            }
          });
          this.checkedExportFields.forEach((item, i) => {
            if (item === '产品系列') {
              this.checkedExportFields.splice(i, 1);
            }
          });
          this.checkedExportFields.forEach((item, i) => {
            if (item === '单套目录价') {
              this.checkedExportFields.splice(i, 1);
            }
          });
          this.checkedExportFields.forEach((item, i) => {
            if (item === '单套价格') {
              this.checkedExportFields.splice(i, 1);
            }
          });
          this.mergeFlag = '2';
        } else {
          this.mergeFlag = '1';
        }
      } else if (row === '合并（显示产品明细）') {
        if (this.checkedExportFormats.indexOf(row) > -1) {
          this.checkedExportFormats.forEach((item, i) => {
            if (item === '合并（不显示产品明细）') {
              this.checkedExportFormats.splice(i, 1);
            }
          });
        }
        this.checkedExportFields.forEach((item, i) => {
          if (item === '产品系列') {
            this.checkedExportFields.splice(i, 1);
          }
        });
        this.checkedExportFields.forEach((item, i) => {
          if (item === '单套目录价') {
            this.checkedExportFields.splice(i, 1);
          }
        });
        this.checkedExportFields.forEach((item, i) => {
          if (item === '单套价格') {
            this.checkedExportFields.splice(i, 1);
          }
        });
        this.mergeFlag = '1';
      }
      if (this.checkedExportFormats.indexOf('合并（不显示产品明细）') === -1 && this.checkedExportFormats.indexOf('合并（显示产品明细）') === -1) {
        this.mergeFlag = '3';
      }
    },
    async init () {
      this.loading = true;
      const res = await api.getUserSettings();
      this.loading = false;
      let json = res.data;
      if (json.status === '200') {
        if (json.data.searchConditions != null) {
          this.searchConditions = JSON.parse(json.data.searchConditions);
        }
        this.form = json.data;

        if (this.form.defaultProductNameSwitch == null) {
          this.form.defaultProductNameSwitch = true;
        }

        if (this.form.defaultParamsSwitch == null) {
          this.form.defaultParamsSwitch = true;
        }
        if (this.form.checkedExportFormats.indexOf('合并（不显示产品明细）') > -1) {
          this.mergeFlag = '2';
        } else if (this.form.checkedExportFormats.indexOf('合并（显示产品明细）') > -1) {
          this.mergeFlag = '1';
        } else {
          this.mergeFlag = '3';
        }
        this.checkedExportFields = this.form.checkedExportFields !== '' && this.form.checkedExportFields !== null ? this.form.checkedExportFields.split(',') : [];
        this.checkedExportFormats = this.form.checkedExportFormats !== '' && this.form.checkedExportFormats !== null ? this.form.checkedExportFormats.split(',') : [];
      }
    },
    cancel () {
      this.$router.go(-1);
    },
    // 保存
    async onSubmit () {
      this.loading = true;
      let params = {
        defaultProductNameSwitch: this.form.defaultProductNameSwitch,
        defaultParamsSwitch: this.form.defaultParamsSwitch,
        exportSwitch: this.form.exportSwitch,
        searchMode: this.form.searchMode,
        settingId: this.form.settingId,
        userId: this.form.userId,
        exportFields: this.checkedExportFields.toString(),
        exportFormats: this.checkedExportFormats.toString(),
        searchConditions: JSON.stringify(this.searchConditions)
      };
      try {
        const res = await api.saveSettingsService(params);
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success(`${this.$t('productAdded.updateSuccess')}`);
          // this.init();
        }
      } catch (error) {
        this.loading = false;
      }
    }
  },
  mounted () {
    this.init();
  }
};
</script>
<style lang="scss">
.person {
  .person-config-button{
    text-align: right;
  }
  .el-checkbox__label {
    display: inline-grid;
    width:200px;
    white-space: pre-line;
    word-wrap: break-word;
    line-height: 20px;
  }
  .el-checkbox{
    margin-left: 30px !important;
    margin-bottom: 20px;
    width: 155px;
  }
  .el-card {
    margin: 30px 0;
  }
  .el-card__header,
  .el-card__body {
    padding: 4px 10px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
}
</style>
<style lang="scss" scoped>
.person {
  text-align: left;
  width: 80%;
  margin: 20px auto;
  .title {
    font-size: 16px;
    float: left;
    // color: #606266;
    line-height: 40px;
    padding-left: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
</style>
